<template>
  <div v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <Banner />
    <div class="edit-content">
      <el-form :model="form" ref="form" :rules="rules" class="info-form">
        <el-form-item prop="realName" label="真实姓名">
          <el-input
            v-model.trim="form.realName"
            placeholder="请输入真实姓名"
            autofocus
            type="text"
            @keyup.enter.native="updateInfo('form')"
          />
        </el-form-item>
        <el-form-item prop="idCardNo" label="身份证号">
          <el-input
            v-model.trim="form.idCardNo"
            placeholder="请输入身份证号"
            type="text"
            @keyup.enter.native="updateInfo('form')"
          />
        </el-form-item>
        <el-form-item prop="phone" label="手机号">
          <el-input
            v-model.trim="form.phone"
            placeholder="请输入11位手机号"
            type="text"
            @keyup.enter.native="updateInfo('form')"
          />
        </el-form-item>
        <div class="operate">
          <el-button type="primary" class="width-btn" @click="updateInfo('form')" style="padding: 10px 34px;">保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updateInfo } from '@/api/user'
import { validateIdCardNo, validatePhone } from '@/utils/validate'
import Banner from '../layout/components/Banner'

export default {
  name: 'EditInfo',
  data() {
    return {
      loading: false,
      form: {
        realName: '',
        idCardNo: '',
        phone: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        idCardNo: [
          { required: true, validator: validateIdCardNo, trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Banner
  },
  mounted() {
    this.form.realName = this.$store.state.user.userInfo.realName
    this.form.idCardNo = this.$store.state.user.userInfo.idCardNo
    this.form.phone = this.$store.state.user.userInfo.phone
  },
  methods: {
    updateInfo(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true
          updateInfo(this.form)
            .then(res => {
              if (res.code === 200) {
                if (res.data.status) {
                  that.$message({
                    message: '保存成功，请重新登录',
                    type: 'success'
                  })
                  setTimeout(function() {
                    that.$store.dispatch('user/clearToken', '')
                    that.loading = false
                    that.$router.push('/login')
                  }, 2000)
                } else {
                  that.loading = false
                  that.$message({
                    message: res.data.msg || '网络连接失败，请检查网络',
                    type: 'error'
                  })
                }
              }
            })
            .catch(() => {
              that.loading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-content {
  max-width: 800px;
  margin: 20px auto;
  background: #fff;
  border-radius: 5px;
  padding: 20px 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  .info-form {
    max-width: 400px;
    margin: 0 auto;
  }
  .operate {
    text-align: center;
  }
}
</style>
